export default __webpack_public_path__ + "static/media/upmenu-sm-light.2ef46924.svg";